import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BreadcrumbService {
  reload$ = new BehaviorSubject(null);
}
